import { getLeftNavDashboardVersion, IsLeftNavDashboardV2, IsSchoolUiDecoupledEnabled } from 'utility/constants';
import { sendErrorToSentry } from '../ErrorBoundary/sendErrorToSentry';

const trackAnalyticsEventInterceptor = window.trackAnalyticsEvent;
window.app_version = BUILD_VERSION;
window.trackAnalyticsEvent = (eventName, properties={}, ...args) => {
    try {
        let productFlow = sessionStorage.getItem('product_flow');
        if(productFlow && properties){
            properties['Product Flow'] = productFlow;
        }
        if(properties){
            properties['App Version'] = BUILD_VERSION;
            properties['Left Nav Dashboard Version'] = getLeftNavDashboardVersion();
            properties['SUI Decoupled'] = IsSchoolUiDecoupledEnabled();
        }
        trackAnalyticsEventInterceptor(eventName, properties, ...args);
    } catch(e) {
        console.error(e);
        sendErrorToSentry("trackAnalyticsEventInterceptor failed", {eventName, properties})
    }
}

var avoInitProps = {
    klassGrade: window.KLASS_GRADE?.code ?? null,
    currentGrade: window.KLASS_GRADE?.code ?? null,
    subjectCode: window.KLASS_DETAIL?.id ? "math": '',
    klass: window.KLASS_DETAIL,
};

export const dispatchAvoEvent = ({ eventName, props, teacherCoreProperties = true, userCoreProperties = true, studentCoreProperties=false }, initProps = avoInitProps) => {
    if (eventName) {

        let teacherCoreProps = {}, studentCoreProps = {}, userCoreProps = {}

        // add teacher core properties
        if (teacherCoreProperties) {
            let klass_grade = initProps?.klassGrade;
            let current_grade = initProps?.currentGrade;
            teacherCoreProps = {
                grade: klass_grade?.toLowerCase() || "NA",
                teacherType: initProps?.teacherType || "Basic",
                isGradeDifferent: !(current_grade?.toString().toLowerCase() === klass_grade?.toString().toLowerCase()),
                class_: initProps?.klass?.name || initProps?.klass?.klassName || "",
                subject: initProps?.subjectCode || "math"
            }
        }

        if(studentCoreProperties) {
            let klass_grade = initProps?.klassGrade;
            let current_grade = initProps?.currentGrade;
            studentCoreProps = {
                grade: klass_grade?.toLowerCase() || "NA",
                mode: "school",
                mathGrade: current_grade?.toLowerCase() || "NA",
                elaGrade: current_grade?.toLowerCase() || "NA"
            }
        }

        // add user core properties (already being passed)
        if (userCoreProperties) {
            userCoreProps = {
                platform: window?.eventInitProps?.platform || initProps?.platform || "web",
                userType: window?.eventInitProps?.userType || initProps?.userType ||"Teacher",
                signupFlow: "classroom_linked"
            }
        }

        props = {
            ...teacherCoreProps,
            ...studentCoreProps,
            ...userCoreProps,
            ...props,
        }

        try {
            if (typeof window.sendEventViaAvoWrapper === 'function') {
                window.sendEventViaAvoWrapper(eventName, props, (APP_MODE === "production") ? 'prod' : 'dev' , "school-ui");
            }
            console.group("SCHOOL UI EVENT DISPATCHED")
            console.log(eventName);
            console.log(props);
            console.groupEnd()
        } catch (e) {
            //  if for some reason events are going through
            console.group("SCHOOL UI EVENT DISPATCH FAILED")
            console.log(eventName);
            console.log(props);
            console.warn("Avo Error", e?.message)
            console.groupEnd()
        }
    }
}


